module.exports = "./img/8294e9167f9325591781e991338d9885.jpg";